<template>
    <div class="content">
        <div class="education_list">
            <div class="education_content" v-for="(v,i) in educationArr" :key="i" @click="editInfo(v)">
                <div class="education_content_top">
                    <span class="college">{{v.college_name}}</span>
                    <span class="timer">{{v.start_date}}-{{v.end_date}}</span>
                </div>
                <div class="education_content_bottom">
                    <span>{{education[v.education_id]}}·{{v.major_name}}·{{way[v.education_way_id]}}</span>
                    <img class="del" :src="require('@/assets/img/del.png')" alt="" @click.stop="deletion(v)">
                </div>
            </div>
        </div>
        <van-button plain type="danger" @click="add">添加</van-button>
        <van-button type="danger" class="go" @click="next" ref="savebtn">下一步</van-button>
        <load :loading="loading"></load>
    </div>
</template>

<script>
import { getWayApi,getEducationApi,getMajorApi,getEduExperienceListApi,getWorkListApi,editEduExpApi } from "@/api/interview";
import Load from "@/components/Loading"
    export default {
        data(){
            return {
                educationArr:[],
                id:sessionStorage.getItem("ID") || 0,
                way:{},
                education:{},
                major:{},
                loading:false,
            }
        },
        methods:{
            // 删除
            deletion(item){
                this.loading = true
                const params = {
                    ...item,
                    status: 0
                }
                editEduExpApi(params).then(res=>{
                    if(res.errNo===0){
                        this.getData()
                    }
                })
            },
            // 添加
            add(){
                this.$router.push({path:"/interviews/education",query:{edit:this.$route.query.edit}})
            },
            // 编辑条目
            editInfo(item){
              console.log(item,'item')
              var info = JSON.stringify(item)
              this.$router.push({path:"/interviews/education",query:{edit:this.$route.query.edit,id: item.id}})
            },
            // 下一步
            next(){
                getWorkListApi({resume_id:this.id}).then(res=>{
                    if(this.$route.query.edit){
                        this.$router.push({path:"/interviews/resume"})
                    } else if(res.result.length>0){
                        this.$router.push({path:"/interviews/worklist"})
                    }else {
                        this.$router.push({path:"/interviews/work"})
                    }
                })
            },
            // 获取数据
            async getData(){
                getEduExperienceListApi({resume_id:this.id}).then(res=>{
                    if(res.errNo===0){
                        this.educationArr = res.result
                    }
                })
                const way = await getWayApi()
                const education = await getEducationApi()
                const major = await getMajorApi()
                this.way = way.result
                this.education = education.result
                this.major = major.result
                this.loading = false
            }
        },
        created(){
            const id = sessionStorage.getItem('ID') || 0
            this.id = id
            if(id){
                this.loading = true
            }
            this.getData()
        },
        mounted() {
            if(this.$route.query.edit){
                this.$refs['savebtn'].innerHTML="保存"
            }
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang="less">
/deep/ .van-button {
    width: 88%;
    margin: 0 auto;
    border-radius: 10px;
}
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .go {
        position: fixed;
        bottom: 10%;
    }
}
.education_list {
    width: 90%;
    padding: 75px 37px 0 43px;
    font-size: 27px;
}
.education_content {
    padding-bottom: 54px;
    .education_content_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 27px;
        .college {
            font-weight: 900;
        }
        .timer {
            color: #a1a1a1;
            font-size: 19px;
        }
    }
    .education_content_bottom {
        display: flex;
        justify-content: space-between;
        .del{
            width: 34px;
            height: 34px;
        }
    }
}
</style>